<header *ngIf="!localeSelected">{{ placeholder }}</header>
<header
    *ngIf="localeSelected && !languagesOnlyOfCountry"
    [attr.title]="localeMappings.countries[localeSelected.country] + (localeSelected.language ? ' (' + localeMappings.languages[localeSelected.language] + ')' : '')"
>
    {{ localeMappings.countries[localeSelected.country] }}
    <span *ngIf="localeSelected.language">({{ localeMappings.languages[localeSelected.language] }})</span>
</header>
<header *ngIf="localeSelected && languagesOnlyOfCountry" [attr.title]="localeMappings.languages[localeSelected.language]">
    {{ localeMappings.languages[localeSelected.language] }}
</header>
<aside [attr.title]="placeholder">▼</aside>
<main *ngIf="active" [style.width]="width + 'px'">
    <div
        *ngFor="let locale of localeOptions"
        [style.fontWeight]="locale.language ? 'normal' : 'bold'"
        [style.paddingLeft]="locale.language ? '40px' : '20px'"
        (click)="handleSelected(locale)"
    >
        {{ localeMappings.languages[locale.language] || localeMappings.countries[locale.country] }}
    </div>
</main>
